import { useState, useEffect, useRef } from 'react';
import { RefreshCw } from 'lucide-react';

export default function UpdatePrompt() {
  const [showUpdate, setShowUpdate] = useState(false);
  const [registration, setRegistration] = useState(null);
  const userAskedUpdate = useRef(false);

  useEffect(() => {
    if (!('serviceWorker' in navigator)) return;

    navigator.serviceWorker.ready.then(reg => {
      setRegistration(reg);

      reg.addEventListener('updatefound', () => {
        const newWorker = reg.installing;
        if (!newWorker) return;
        newWorker.addEventListener('statechange', () => {
          if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
            setShowUpdate(true);
          }
        });
      });
    });

    let refreshing = false;
    const onControllerChange = () => {
      if (!userAskedUpdate.current || refreshing) return;
      refreshing = true;
      window.location.reload();
    };
    navigator.serviceWorker.addEventListener('controllerchange', onControllerChange);
    return () => navigator.serviceWorker.removeEventListener('controllerchange', onControllerChange);
  }, []);

  const handleUpdate = () => {
    userAskedUpdate.current = true;
    if (registration?.waiting) {
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
    }
    setShowUpdate(false);
  };

  if (!showUpdate) return null;

  return (
    <div data-testid="update-prompt"
      className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:w-80 bg-[#111] border border-[#C9A962] p-4 z-50 shadow-2xl">
      <div className="flex items-start gap-3">
        <RefreshCw className="w-5 h-5 text-[#C9A962] shrink-0 mt-0.5" />
        <div className="flex-1">
          <p className="text-white text-sm font-medium mb-1">Nueva version disponible</p>
          <p className="text-zinc-400 text-xs mb-3">Hay una actualizacion de FeConCiencia lista para instalar.</p>
          <div className="flex gap-2">
            <button onClick={handleUpdate} data-testid="update-now-btn"
              className="flex-1 bg-[#C9A962] text-black text-xs font-medium py-2 px-3 hover:bg-[#DCC286] transition-colors">
              Actualizar ahora
            </button>
            <button onClick={() => setShowUpdate(false)}
              className="text-zinc-500 text-xs py-2 px-3 hover:text-zinc-300 transition-colors">
              Despues
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
